"use client";
import React from "react";
import Link from "next/link";
import { useBrowse } from "../../lib/hooks";
import { getLocationBookingPath } from "@/consts/serviceHubs";
import type { Location } from "@/lib/api/types";

const PlaceCard = ({
  name,
  pathId,
  address,
  city,
  state,
  zipcode,
  images,
  cardImage,
}: Location) => {
  const { idOnMarker, setCard, removeCard, serviceSlug } = useBrowse();
  const fullAddress = [
    address,
    city,
    [state, zipcode].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(", ");
  const image = cardImage ?? images[0];
  return (
    <li>
      <Link
        id={`place-${pathId}`}
        href={getLocationBookingPath(pathId, serviceSlug)}
        aria-label={`Go to ${name} details`}
        className={`place-card ${pathId === idOnMarker ? "is-pin-active" : ""}`}
        onPointerEnter={(event) => {
          if (event.pointerType === "mouse") setCard(pathId);
        }}
        onPointerLeave={removeCard}
        onFocus={() => setCard(pathId)}
        onBlur={removeCard}
      >
        {image ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img
            className="place-card-image"
            src={image}
            alt=""
            loading="lazy"
            decoding="async"
          />
        ) : (
          <span
            className="place-card-image place-card-placeholder"
            aria-hidden="true"
          >
            {name.charAt(0)}
          </span>
        )}
        <div className="place-card-info">
          <h2>{name}</h2>
          <p>{fullAddress}</p>
        </div>
      </Link>
    </li>
  );
};

const PlaceList = ({ places }: { places: Location[] }) => {
  const { isMapView } = useBrowse();
  return (
    <div id="Contents" className={isMapView ? "is-mapview" : "is-listview"}>
      <ul className="location-cards" aria-label="Locations">
        {places.map((place) => (
          <PlaceCard key={place.pathId} {...place} />
        ))}
      </ul>
    </div>
  );
};

export default PlaceList;
